import React, { useState, useEffect } from 'react';
import './PromotionSection.css';
import { AnimatedSection } from '../../AnimatedSection';

const PromotionSection = () => {
  // Array of 8 player images
  const playerImages = [
    '/home_data/section2/Frame 47.png',
    '/home_data/section2/Frame 47 (1).png',
    '/home_data/section2/Bill Russel.png',
    '/home_data/section2/Brandi Chastain.png',
    '/home_data/section2/Serena.png',
    '/home_data/section2/Vince Lombardi.png',
    '/home_data/section2/image 1.png'
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Text animation states
  const [dotsVisible, setDotsVisible] = useState([true, true, true]);
  const [showWeAre, setShowWeAre] = useState(false);
  const [showThere, setShowThere] = useState(false);
  const [weAreText, setWeAreText] = useState('');
  const [thereText, setThereText] = useState('');
  const [hasAnimated, setHasAnimated] = useState(false); // ✅ only once

  // Bottom squares sliding animation state
  const [slideOffset, setSlideOffset] = useState(0);

  // Auto-change player image every 0.5s
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === playerImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 500);

    return () => clearInterval(interval);
  }, []);

  // Bottom squares sliding animation
  useEffect(() => {
    const interval = setInterval(() => {
      setSlideOffset((prevOffset) => {
        const newOffset = prevOffset - 11;
        return newOffset <= -1111 ? 0 : newOffset;
      });
    }, 100);
    return () => clearInterval(interval);
  }, []);

  // ✅ Function to animate text once
  const startAnimation = () => {
    if (hasAnimated) return;
    setHasAnimated(true);

    // Phase 1: Remove dots
    setTimeout(() => setDotsVisible([false, true, true]), 1500);
    setTimeout(() => setDotsVisible([false, false, true]), 1800);
    setTimeout(() => setDotsVisible([false, false, false]), 2100);

    // Phase 2: Show "WE ARE"
    setTimeout(() => {
      setShowWeAre(true);
      animateText('WE ARE', setWeAreText, () => {
        // Phase 3: Show "THERE"
        setTimeout(() => {
          setShowThere(true);
          animateText('THERE', setThereText);
        }, 700);
      });
    }, 2500);
  };

  // Animate text letters
  const animateText = (text, setTextFunction, onComplete) => {
    let index = 0;
    const timer = setInterval(() => {
      if (index < text.length) {
        setTextFunction(text.substring(0, index + 1));
        index++;
      } else {
        clearInterval(timer);
        if (onComplete) onComplete();
      }
    }, 100);
  };

  // Scroll listener to trigger animation once
  useEffect(() => {
    const toggleScrolled = () => {
      if (window.scrollY > 600) {
        startAnimation();
      }
    };

    window.addEventListener('scroll', toggleScrolled);
    return () => window.removeEventListener('scroll', toggleScrolled);
  }, [hasAnimated]);

  return (
    <section className="promotion-section section" id="section2">
      {/* Background geometric shapes */}
      <div className="geometric-shapes-desktop">
      </div>

      <div className="geometric-shapes-mobile">
      </div>

      {/* Main content */}
      <div className="promotion-content">
        {/* Title section */}
        <AnimatedSection>
          <div className="title-section">
            <h1 className="main-title-section2">
              <span className="title-line">WHEN</span>
              <span className="title-line">EVERYTHING</span>
              <span className="title-line">IS ON THE LINE</span>
              <span className="title-line">
                {dotsVisible[0] && <span className="ellipsis-dot">.</span>}
                {dotsVisible[1] && <span className="ellipsis-dot">.</span>}
                {dotsVisible[2] && <span className="ellipsis-dot">.</span>}
                {showWeAre && <span>{weAreText}</span>}
                {showThere && <br />}
                {showThere && <span>{thereText}</span>}
              </span>
            </h1>
          </div>
        </AnimatedSection>
        {/* Content area */}
        <div className="content-area">
          {/* Left side */}
          <AnimatedSection>
            <div className="text-content">

              <p className="text-promotion">
                GAME 7, the two greatest words in sports.<br /> It is the ultimate test
                of ability and performance under pressure. It’s winner takes all.
                The stage where greatness is born. Stars become champions. And
                champions become legends. To win, you must execute in the moment,
                but victory is also earned through a lifetime of commitment and
                sacrifice.
              </p>
              {/* <button className="about-us-button">ABOUT US</button> */}
            </div>
          </AnimatedSection>

          {/* Right side - Diagonal image */}
         
          <div className="image-content">
            <div className="diagonal-image-container">
              <img
                src={playerImages[currentImageIndex]}
                alt="Player"
                className="diagonal-image"
              />
            </div>
          </div>
        
        </div>

        {/* Bottom section - sliding logos */}
        <div className="bottom-squares-container">
          <div className="bottom-squares-border"></div>
          <div className="slider-content1">
            <div style={{ display: 'flex', gap: '2rem' }}> 
              <img
                src="/home_data/section2/realimg/1.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/2.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/3.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/4.svg"
                alt="Logo 4"
                className="square-image"
              />
              
              <img
                src="/home_data/section2/realimg/5.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/6.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/7.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/8.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/9.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/10.svg"
                alt="Logo 4"
                className="square-image"
              />

              <img
                src="/home_data/section2/realimg/1.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/2.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/3.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/4.svg"
                alt="Logo 4"
                className="square-image"
              />
              
              <img
                src="/home_data/section2/realimg/5.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/6.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/7.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/8.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/9.svg"
                alt="Logo 4"
                className="square-image"
              />
              <img
                src="/home_data/section2/realimg/10.svg"
                alt="Logo 4"
                className="square-image"
              />
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromotionSection;